import { ThemedPage } from "@ots-frontend/ots-ui";
import {LiveMap} from "../../components/LiveMap/LiveMap";

export const MapPage = () => {
  return (
    <ThemedPage>
      <LiveMap/>
    </ThemedPage>
  );
};
